import { render, staticRenderFns } from "./TableAtenciones.vue?vue&type=template&id=791989fc"
import script from "./TableAtenciones.vue?vue&type=script&lang=js"
export * from "./TableAtenciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports